import { Injectable } from '@angular/core';
import { PlaybackState } from '../models/PlaybackState';

// CURRENTLY NOT USED

@Injectable()
export class DashboardsUpdateService {
    private updateTimer: NodeJS.Timer = null;

    /**
     * Starts a timer, which will call the callback function each second.
     * @param callback The callback function to call each second.
     */
    start(callback: (...args: any[]) => void): void {
        this.updateTimer = setInterval(callback, 1000);
        // interval could be configurable
    }

    /**
     * Stops the started timer.
     */
    stop(): void {
        clearInterval(this.updateTimer);
        this.updateTimer = null;
    }

    getState(): PlaybackState {
        return this.updateTimer === null ? PlaybackState.Stopped : PlaybackState.Started;
    }
}
